import React from 'react'
import Cookies from 'universal-cookie'
import { BACKEND_URL } from '../config'

const AuthCallback = (props) => {
    // const location = useLocation();
    const [accessTokenDisplay, setAccessTokenDisplay] = React.useState('')
    const processAccessToken = async () => {
        const params = new URLSearchParams(props.location.search)

        const code = params.get('code')

        const res = await fetch(`${BACKEND_URL}/api/oauth/token?code=${code}`)
        const data = await res.json()

        const cookies = new Cookies()

        // cookies.set('loggedIn', true)
        cookies.set('user_id', 1)
        cookies.set('firstname', data.payload_data.name)
        cookies.set('token', data.token_data.access_token)
        // cookies.set('token', 'peanut')
        cookies.set('superuser', true)
        cookies.set('organization-admin', false)
        cookies.set('branch-admin', false)
        cookies.set('branch-user', false)

        // setAccessTokenDisplay(data.token_data.access_token)
        window.location = `dashboard`
    }

    React.useEffect(() => {
        processAccessToken()
    })
    return <div></div>
}

export default AuthCallback



// WEBPACK FOOTER //
// src/Routes/AuthCallback.js